import {ApplicationConfiguration} from './application-configurations';
import {baseBackendConfiguration, baseFrontendConfiguration, fnolPublishedFormsBackend} from './base-environment';
import {buildInfo} from './build-info';

export const environment: ApplicationConfiguration = {
  production: false,
  oidc: {
    authority: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_pazyLodKK",
    client_id: "2qtsdn2r3e1l5f1h6d8ri9cmfe",
    redirect_uri: "https://fnol-app.devtest.pxcatclaim.com/callback",
    post_logout_redirect_uri: "https://fnol-app.devtest.pxcatclaim.com/",
    response_type: "code",
    scope: "profile email openid",
    automaticSilentRenew: true,
    loadUserInfo: true
  },
  claimManagerBackend: {
    ...baseBackendConfiguration,
    baseUrl: 'https://fnol-api.devtest.pxcatclaim.com',
  },
  claimManagerFrontend: {
    ...baseFrontendConfiguration,
    baseUrl: 'https://fnol-app.devtest.pxcatclaim.com',
  },
  fnolPublishedFormsBackend: {...fnolPublishedFormsBackend, baseUrl: 'https://forms-fnol-app.devtest.pxcatclaim.com'},
  buildInfo: {
    commitId: buildInfo.commitId,
    buildDate: buildInfo.buildDate,
    version: buildInfo.version
  }
};
